import SampleFooter from "./SampleFooter";
import SampleGlobalFooter from "./SampleGlobalFooter";
import SampleSiteFooter from "./SampleSiteFooter";

export default SampleFooter;
export { SampleGlobalFooter, SampleSiteFooter };
